import { actions } from './actions'

const initialState = {
  productos: {
    data: [],
    loading: false,
    error: '',
  },
  mapas: {
    data: [],
    loading: false,
    error: '',
  },
  producto: {
    data: null,
    loading: false,
    error: '',
  },
  productosAdicionales: {
    data: [],
    loading: false,
    error: '',
  },
  productosAdicionalesProducto: {
    data: [],
    loading: false,
    error: '',
  },
  productosAvatares: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function productoReducer(state = initialState, action) {
  switch (action.type) {
    case actions.PRODUCTOS_LOAD_REQUESTED:
      return { ...state, productos: { ...state.productos, loading: true } }
    case actions.PRODUCTOS_LOAD_FILTERED_REQUESTED:
      return { ...state, productos: { ...state.productos, loading: true } }
    case actions.PRODUCTOS_LOAD_SUCCEEDED:
      return { ...state, productos: { ...state.productos, data: action.payload, loading: false } }
    case actions.PRODUCTOS_LOAD_FILED:
      return { ...state, productos: { ...state.productos, loading: false, error: action.error } }

    case actions.PRODUCTOS_BYID_LOAD_REQUESTED:
      return { ...state, productos: { ...state.productos, loading: true } }
    case actions.PRODUCTOS_BYID_LOAD_SUCCEEDED:
      return { ...state, productos: { ...state.productos, data: action.payload, loading: false } }
    case actions.PRODUCTOS_BYID_LOAD_FILED:
      return { ...state, productos: { ...state.productos, loading: false, error: action.error } }

    case actions.MAPAS_LOAD_REQUESTED:
      return { ...state, mapas: { ...state.mapas, loading: true } }
    case actions.MAPAS_LOAD_SUCCEEDED:
      return { ...state, mapas: { ...state.mapas, data: action.payload, loading: false } }
    case actions.MAPAS_LOAD_FILED:
      return { ...state, mapas: { ...state.mapas, loading: false, error: action.error } }
    case actions.PRODUCTO_BYID_LOAD_REQUESTED:
      return {
        ...state,
        producto: { ...state.producto, loading: true, error: '' },
      }
    case actions.PRODUCTO_BYID_LOAD_SUCCEEDED:
      return {
        ...state,
        producto: { ...state.producto, data: action.payload, loading: false, error: '' },
      }
    case actions.PRODUCTO_BYID_LOAD_FILED:
      return {
        ...state,
        producto: { ...state.producto, data: null, loading: false, error: action.error },
      }
    case actions.PRODUCTO_BYID_LOAD_INSERT_REQUESTED:
      return {
        ...state,
        producto: { ...state.producto, data: null, loading: false, error: '' },
      }
    case actions.PRODUCTO_UPDATE_REQUESTED:
      return {
        ...state,
        producto: { ...state.producto, loading: true, error: '' },
      }
    case actions.PRODUCTO_UPDATE_SUCCEEDED:
      return {
        ...state,
        producto: { ...state.producto, data: action.payload, loading: false, error: '' },
      }
    case actions.PRODUCTO_UPDATE_FILED:
      return {
        ...state,
        producto: { ...state.producto, loading: false, error: action.error },
      }
    case actions.PRODUCTO_INSERT_REQUESTED:
      return {
        ...state,
        producto: { ...state.producto, loading: true, error: '' },
      }
    case actions.PRODUCTO_INSERT_SUCCEEDED:
      return {
        ...state,
        producto: { ...state.producto, data: action.payload, loading: false, error: '' },
      }
    case actions.PRODUCTO_INSERT_FILED:
      return {
        ...state,
        producto: { ...state.producto, loading: false, error: action.error },
      }
    case actions.PRODUCTO_DELETE_REQUESTED:
      return {
        ...state,
        productos: { ...state.productos, loading: true, error: '' },
      }
    case actions.PRODUCTO_DELETE_SUCCEEDED:
      return {
        ...state,
        productos: {
          ...state.productos,
          data: state.productos.data.filter(producto => producto.id !== action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.PRODUCTO_DELETE_FILED:
      return {
        ...state,
        productos: { ...state.productos, loading: false, error: action.error },
      }
    case actions.PRODUCTOS_DELETE_REQUESTED:
      return {
        ...state,
        productos: { ...state.productos, loading: true, error: '' },
      }
    case actions.PRODUCTOS_DELETE_SUCCEEDED:
      return {
        ...state,
        productos: {
          ...state.productos,
          data: state.productos.data.filter(prod => !action.payload.includes(prod.id)),
          loading: false,
          error: '',
        },
      }
    case actions.PRODUCTOS_DELETE_FILED:
      return {
        ...state,
        productos: { ...state.productos, loading: false, error: action.error },
      }
    case actions.PRODUCTOS_ADICIONALES_LOAD_REQUESTED:
      return { ...state, productosAdicionales: { ...state.productosAdicionales, loading: true } }
    case actions.PRODUCTOS_ADICIONALES_LOAD_SUCCEEDED:
      return {
        ...state,
        productosAdicionales: {
          ...state.productosAdicionales,
          data: action.payload,
          loading: false,
        },
      }
    case actions.PRODUCTOS_ADICIONALES_LOAD_FILED:
      return {
        ...state,
        productosAdicionales: {
          ...state.productosAdicionales,
          loading: false,
          error: action.error,
        },
      }
    case actions.PRODUCTOS_ADICIONALES_BY_PRODUCTO_ID_LOAD_REQUESTED:
      return {
        ...state,
        productosAdicionalesProducto: { ...state.productosAdicionalesProducto, loading: true },
      }
    case actions.PRODUCTOS_ADICIONALES_BY_PRODUCTO_ID_LOAD_SUCCEEDED:
      return {
        ...state,
        productosAdicionalesProducto: {
          ...state.productosAdicionalesProducto,
          data: action.payload,
          loading: false,
        },
      }
    case actions.PRODUCTOS_ADICIONALES_BY_PRODUCTO_ID_LOAD_FILED:
      return {
        ...state,
        productosAdicionalesProducto: {
          ...state.productosAdicionalesProducto,
          loading: false,
          error: action.error,
        },
      }
    case actions.PRODUCTOS_ADICIONALES_UPDATE_REQUESTED:
      return {
        ...state,
        productosAdicionalesProducto: {
          ...state.productosAdicionalesProducto,
          loading: true,
          error: '',
        },
      }
    case actions.PRODUCTOS_ADICIONALES_UPDATE_SUCCEEDED:
      return {
        ...state,
        productosAdicionalesProducto: {
          ...state.productosAdicionalesProducto,
          data: action.payload,
          loading: false,
          error: '',
        },
      }
    case actions.PRODUCTOS_ADICIONALES_UPDATE_FILED:
      return {
        ...state,
        productosAdicionalesProducto: {
          ...state.productosAdicionalesProducto,
          loading: false,
          error: action.error,
        },
      }

    case actions.PRODUCTOS_ADICIONALES_DELETE_REQUESTED:
      return {
        ...state,
        productosAdicionalesProducto: {
          ...state.productosAdicionalesProducto,
          loading: true,
          error: '',
        },
      }
    case actions.PRODUCTOS_ADICIONALES_DELETE_SUCCEEDED:
      return {
        ...state,
        productosAdicionalesProducto: {
          ...state.productosAdicionalesProducto,
          data: [],
          loading: false,
          error: '',
        },
      }
    case actions.PRODUCTOS_ADICIONALES_DELETE_FILED:
      return {
        ...state,
        productosAdicionalesProducto: {
          ...state.productosAdicionalesProducto,
          loading: false,
          error: action.error,
        },
      }
    case actions.PRODUCTOS_AVATARES_LOAD_REQUESTED:
      return { ...state, productosAvatares: { ...state.productosAvatares, loading: true } }
    case actions.PRODUCTOS_AVATARES_LOAD_SUCCEEDED:
      return {
        ...state,
        productosAvatares: {
          ...state.productosAvatares,
          data: action.payload,
          loading: false,
        },
      }
    case actions.PRODUCTOS_AVATARES_LOAD_FAILED:
      return {
        ...state,
        productosAvatares: {
          ...state.productosAvatares,
          loading: false,
          error: action.error,
        },
      }
    default:
      return state
  }
}
